import { createUserManager } from 'redux-oidc';
import oauthConfig from './oauthConfig';

export default createUserManager(oauthConfig());
